const ResetPasswordFormFields = {
  newPassword: {
    id: 'new-password',
    name: 'New Password',
    label: 'reset.pass.form.password.new.label'
  },
  confirmPassword: {
    id: 'confirm-password',
    name: 'Confirm Password',
    label: 'reset.pass.form.password.confirm.label'
  }
};

export default ResetPasswordFormFields;
